import {FC, useEffect, useMemo} from "react";
import {App, Button, Flex} from "antd";
import styles from './AuthPage.module.css';
import {LoginOutlined} from "@ant-design/icons";
import {AUTHORIZE_REDIRECT_URL} from "../../constants/constants.ts";
import {useCheckAuth} from "../../hooks/useCheckAuth.ts";

const ERROR_MESSAGES_MAP = {
    'oauth': 'Произошла ошибка при авторизации через VATSIM',
    'access': 'Для получения доступа к системе обратитесь к VATRUS4'
} as Record<string, string>;

export const AuthPage: FC = () => {
    const { message } = App.useApp();
    const params = useMemo(() => new URLSearchParams(window.location.search), []);

    useEffect(() => {
        const errorParam = params.get('error');
        if(errorParam) {
            void message.error(ERROR_MESSAGES_MAP[errorParam] || 'Произошла неизвестная ошибка');
        }
    }, [params]);

    useCheckAuth({
        redirectOnSuccess: '/'
    });

    return (
        <Flex align="center" justify="center" className={styles.container}>
            <Button
                type="primary"
                size="large"
                icon={<LoginOutlined />}
                href={AUTHORIZE_REDIRECT_URL}
            >Войти с помощью VATSIM</Button>
        </Flex>
    );
}